import React from "react"
import PropTypes from "prop-types"

import css from "./RatingBadge.scss"

const Star = ({ partial, color }) => {
    if (partial) {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18">
                <g fill="none">
                    <path d="M0 18h18V0H0z" />
                    <path
                        fill="#DBDBDB"
                        d="M12.65 15.72c-.16 0-.33-.04-.48-.12l-3.19-1.7-3.2 1.67c-.34.18-.76.15-1.08-.09a1.03 1.03 0 0 1-.41-1.01l.62-3.55L2.34 8.4a1.03 1.03 0 0 1 .58-1.77l3.56-.5 1.6-3.23c.18-.35.55-.56.94-.57.4 0 .75.22.92.58l1.59 3.23 3.56.53a1.03 1.03 0 0 1 .57 1.77l-2.59 2.5.6 3.56c.07.39-.09.78-.41 1-.18.14-.4.2-.61.2z"
                    />
                    <path d="M0 18h18V0H0z" />
                    <path
                        fill={color}
                        d="m8.98 13.91-3.2 1.67c-.34.18-.76.15-1.08-.09a1.03 1.03 0 0 1-.41-1.01l.62-3.55-2.57-2.52a1.03 1.03 0 0 1 .58-1.77l3.56-.5 1.6-3.23c.18-.35.55-.56.94-.57.26 0 .25 3.85-.04 11.57z"
                    />
                </g>
            </svg>
        )
    } else {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18">
                <g fill="none">
                    <path d="M0 18h18V0H0z" />
                    <path
                        fill={color}
                        d="M12.65 15.717a1.04 1.04 0 0 1-.485-.12L8.981 13.91l-3.193 1.667c-.35.185-.77.153-1.092-.083a1.03 1.03 0 0 1-.409-1.015l.62-3.548L2.335 8.41a1.033 1.033 0 0 1-.259-1.063 1.03 1.03 0 0 1 .84-.703l3.565-.508L8.084 2.91c.177-.355.541-.558.931-.575.4.001.754.224.93.581l1.584 3.235 3.562.528c.393.06.713.33.835.708.121.38.02.786-.266 1.063l-2.586 2.506.597 3.551c.067.391-.09.78-.414 1.012a1.026 1.026 0 0 1-.607.198z"
                    />
                </g>
            </svg>
        )
    }
}

const RatingBadge = ({ averageRating, totalRatings, showText, showRatingCount, showAvgRating }) => {
    let ratingColor = "success"
    let starColor = {
        success: "#208376",
        caution: "#d5410b",
        error: "#e51f47",
        disabled: "#dbdbdb",
    }

    const createStars = (averageRating) => {
        const stars = []
        for (let starIndex = 0; starIndex < 5; starIndex++) {
            if (averageRating >= starIndex) {
                if (Math.floor(averageRating) >= starIndex + 1) {
                    stars.push(<Star key={starIndex} color={starColor[ratingColor]} />)
                } else if (averageRating - Math.trunc(averageRating) == 0) {
                    stars.push(<Star key={starIndex} color={starColor.disabled} />)
                } else if (averageRating - Math.trunc(averageRating) > 0) {
                    stars.push(<Star key={starIndex} partial color={starColor[ratingColor]} />)
                }
            } else {
                stars.push(<Star key={starIndex} color={starColor.disabled} />)
            }
        }
        return stars
    }

    // Altering logic for initial testing
    if (averageRating <= 1.9) {
        ratingColor = "error"
    } else if (averageRating <= 2.9) {
        ratingColor = "caution"
    } else if (averageRating > 3.0) {
        ratingColor = "success"
    }

    return (
        <div className={"flex alignCenter flexWrap"}>
            {averageRating >= 0 && createStars(averageRating)}
            {showAvgRating && (
                <div className={`smallMedium ${css.marginLeft8} ${css[ratingColor]}`}>{averageRating}</div>
            )}
            {showRatingCount && (
                <div className={`xSmallRegular textSecondary ${css.marginLeft8}`}>
                    {showText ? `(${totalRatings} ratings)` : `(${totalRatings})`}
                </div>
            )}
        </div>
    )
}

Star.propTypes = {
    partial: PropTypes.bool,
    color: PropTypes.string,
}

RatingBadge.propTypes = {
    averageRating: PropTypes.number,
    totalRatings: PropTypes.number,
    showText: PropTypes.bool,
    showRatingCount: PropTypes.bool,
    showAvgRating: PropTypes.bool,
}

RatingBadge.defaultProps = {
    showAvgRating: true,
}

export default RatingBadge
